import { iconContent, Icon } from "@customer-tools-web/component-ui";
import { Menu } from "antd";
import * as React from "react";
import styled from "styled-components";

import { MenuItemType } from "../Header";
import { NavigatorLink } from "../components/NavigatorLink";

import { SubMenuWithForm } from "./SubMenuWithForm";
export type Menu_Keys_Type =
  | "reportings"
  | "listings"
  | "leads"
  | "insights"
  | "search-properties"
  | "iq-agent"
  | "brickz"
  | "listings-management"
  | "scheduled-manager"
  | "agent"
  | "add-listing"
  | "subscriptions"
  | "search-property"
  | "team"
  | "management"
  | "setting"
  | "user-guide"
  | "help-centre"
  | "agent-net-link"
  | "log-out"
  | "open-consumer-page-sf"
  | "open-consumer-page-my"
  | "language-back"
  | "language"
  | "enquiry"
  | "allocations"
  | "watermark"
  | "en-GB"
  | "zh-HK"
  | "zh-CN"
  | "ms-MY"
  | "quality"
  | "create-new-listing"
  | "fsbo-alerts"
  | "property-wanted"
  | "market-analytics"
  | "market-watch"
  | "dashboard"
  | "enquiryManagement"
  | "adminTools"
  | "announcements"
  | "areaCondoSpecialist"
  | "areaCondoSpecialistSelfServe"
  | "specialistReport"
  | "credit-brickz"
  | "payment-history"
  | "dynamic-pricing";

export const useMenus = () => {
  return {
    renderMenus,
    renderButtons,
  };
  function renderButtons(options: {
    menus: MenuItemType[];
    onClick: (key: Menu_Keys_Type) => void;
  }) {
    const { menus, onClick } = options;
    return (
      <>
        {menus.map(
          (item) =>
            item.getCustomNode && (
              <div key={item.key} onClick={() => onClick(item.key)}>
                {item.getCustomNode(item)}
              </div>
            )
        )}
      </>
    );
  }

  function renderMenus(options: {
    currentKey: string;
    defaultOpenKeys?: Menu_Keys_Type[];
    menus: MenuItemType[];
    mode: "inline" | "horizontal";
    onClick: (key: Menu_Keys_Type, close?: boolean) => void;
    isDrawerOpen?: boolean;
    onSubMenuTitleMouseEnter?: (e: any) => void;
    hideSubMenuKey?: string;
  }) {
    const {
      menus,
      mode = "horizontal",
      onClick,
      currentKey,
      defaultOpenKeys = [],
      isDrawerOpen,
      onSubMenuTitleMouseEnter,
      hideSubMenuKey,
    } = options;

    const renderItemTooltipPanelLabel = (item: MenuItemType) => {
      if (!item.tooltipPanelLabel) {
        return item.label;
      }

      const isOpen = isDrawerOpen || false;
      return item.tooltipPanelLabel(isOpen, () => onClick(item.key));
    };

    return (
      <NavMenu
        data-test="mobile-nav-menu"
        selectedKeys={[currentKey]}
        defaultOpenKeys={defaultOpenKeys}
        mode={mode}
      >
        {menus.map((item) =>
          item &&
          item.subMenus &&
          (item.subMenus.filter((item) => !!item) || []).length > 0 ? (
            <Menu.SubMenu
              key={item.key}
              popupClassName={"header-submenu-popup"}
              onTitleMouseEnter={(e) =>
                onSubMenuTitleMouseEnter && onSubMenuTitleMouseEnter(e)
              }
              onTitleClick={item?.onTitleClick}
              title={
                <NavigatorLink
                  onClick={() => onClick(item.key, false)}
                  itemRouterOptions={item.routerOptions}
                  itemLink={""}
                  itemLabel={
                    <>
                      {item.icon && <MenuIcon type={item.icon} />}
                      {renderItemTooltipPanelLabel(item)}
                      {item?.getCustomTagNode}
                      {item.needOpenIcon && (
                        <MenuIcon type="external-link-lg" />
                      )}
                    </>
                  }
                  dataTest={item.dataTest}
                  shouldUseRouter={item.shouldUseRouter}
                  openInSameTab={item.openInSameTab}
                />
              }
            >
              <Menu.Item key={item.key}>
                <NavigatorLink
                  itemRouterOptions={item.routerOptions}
                  itemLink={item.link || "#"}
                  itemLabel={item.label}
                  dataTest={item.dataTest}
                  shouldUseRouter={item.shouldUseRouter}
                  openInSameTab={item.openInSameTab}
                />
              </Menu.Item>
              {hideSubMenuKey !== item.key &&
                item.subMenus.map((item) => {
                  return (
                    item &&
                    !item.getCustomNode &&
                    (item.subMenusWithForm ? (
                      <Menu.Item key={item.key}>
                        <SubMenuWithForm
                          title={item.label}
                          keyName={item.key}
                          trackMenuTap={item.subMenusWithForm.trackMenuTap}
                        />
                      </Menu.Item>
                    ) : (
                      <Menu.Item
                        key={item.key}
                        onClick={(e) => {
                          onClick(item.key);
                          item.onTitleClick && item.onTitleClick(e);
                        }}
                      >
                        <NavigatorLink
                          itemRouterOptions={item.routerOptions}
                          itemLink={item.link || "#"}
                          onClick={item.click}
                          itemLabel={
                            <>
                              {item.icon && <MenuIcon type={item.icon} />}
                              {renderItemTooltipPanelLabel(item)}
                              {item.needOpenIcon && (
                                <MenuIcon type="external-link-lg" />
                              )}
                            </>
                          }
                          dataTest={item.dataTest}
                          shouldUseRouter={item.shouldUseRouter}
                          openInSameTab={item.openInSameTab}
                        />
                      </Menu.Item>
                    ))
                  );
                })}
            </Menu.SubMenu>
          ) : (
            !item.getCustomNode && (
              <Menu.Item key={item.key} onClick={() => onClick(item.key)}>
                {item.getCustomTagNode}
                <NavigatorLink
                  itemRouterOptions={item.routerOptions}
                  itemLink={item.link || "#"}
                  onClick={item.click}
                  itemLabel={
                    <>
                      {item.icon && (
                        <MenuIcon
                          iconSize={item?.iconSize}
                          iconMarginRight={item?.iconMarginRight}
                          type={item.icon}
                        />
                      )}
                      {renderItemTooltipPanelLabel(item)}
                      {item.needOpenIcon && (
                        <MenuIcon type="external-link-lg" />
                      )}
                    </>
                  }
                  dataTest={item.dataTest}
                  shouldUseRouter={item.shouldUseRouter}
                  openInSameTab={item.openInSameTab}
                />
              </Menu.Item>
            )
          )
        )}
      </NavMenu>
    );
  }
};

const NavMenu = styled(Menu)`
  &.ant-menu-root {
    .ant-menu-item {
      a {
        display: flex;
      }
      a[data-test="user-guide"] {
        i::before {
          padding-left: 6px;
        }
      }
    }
    &.ant-menu-horizontal {
      width: 100%;
      padding-left: 18px;
      .ant-menu-submenu-selected {
        border-bottom-color: ${(props) => props.theme.menuActiveColor};
        .ant-menu-submenu-arrow {
          color: ${(props) => props.theme.menuActiveColor};
        }
      }
      .ant-menu-submenu-horizontal {
        .ant-menu-submenu-arrow {
          font-family: "rui-icon", sans-serif;
          font-weight: 100;
          font-style: normal;
          vertical-align: middle;
          line-height: 0;
          margin-left: 4px;
          :before {
            content: "${iconContent["arrow-down"]}";
          }
        }
        &:hover {
          border-bottom-color: ${(props) => props.theme.menuHoverColor};
          color: ${(props) => props.theme.menuHoverColor};
          .ant-menu-submenu-arrow {
            color: ${(props) => props.theme.menuHoverColor};
          }
        }
        &.ant-menu-submenu-open {
          color: ${(props) => props.theme.menuActiveColor};
          border-bottom-color: ${(props) => props.theme.menuActiveColor};
          .ant-menu-submenu-arrow {
            color: ${(props) => props.theme.menuActiveColor};
          }
        }
      }
      .submenu-item-title-text,
      a {
        color: ${(props) => props.theme.textDeepGray};
        text-decoration: none;
      }
      li.ant-menu-item-selected,
      li.ant-menu-item-active,
      li.ant-menu-submenu-selected .ant-menu-submenu-title,
      li.ant-menu-submenu-active .ant-menu-submenu-title,
      ul.ant-menu-sub li.ant-menu-item-selected,
      ul.ant-menu-sub li.ant-menu-item-active {
        border-bottom-color: ${(props) => props.theme.menuActiveColor};
        .submenu-item-title-text,
        a {
          color: ${(props) => props.theme.menuActiveColor};
        }
      }
      > li {
        margin: 0 4px;
        padding: 0 8px;
        &.ant-menu-item {
          font-size: ${(props) => props?.theme?.fontSize?.caption};
          font-weight: 700;
        }
        &.ant-menu-submenu {
          > div.ant-menu-submenu-title {
            padding: 0;
            font-size: ${(props) => props?.theme?.fontSize?.caption};
            font-weight: 700;
          }
        }
      }
    }
  }
`;

const agentNetIconStyles = `
  margin-left: 10px;
  font-size: 18px;
`;

const externalLinkIconStyles = `
  font-size: 18px;
  margin-left: 5px;
`;

const MenuIcon = styled(Icon)<{ iconSize?: string; iconMarginRight?: string }>`
  :first-child {
    padding-right: 11px;
  }
  :last-child {
    padding-left: 5px;
  }
  font-size: ${(props: any) =>
    props?.iconSize ? props.iconSize : props?.theme?.fontSize?.title1};
  color: ${(props) => props.theme.textDeepGray};
  margin-right: ${(props) =>
    props.iconMarginRight ? props.iconMarginRight : "8px"};

  ${(props) => props.type === "agent-net-icon" && agentNetIconStyles};
  ${(props) => props.type === "external-link-lg" && externalLinkIconStyles};
`;
